import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[16],
    padding: theme.spacing(3, 4),
    margin: theme.spacing(4),
    maxWidth: '550px',
    width: '100%',
    maxHeight: '90vh',
    overflowY: 'auto',
    borderRadius: '16px',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
      padding: theme.spacing(2),
      width: 'calc(100% - 16px)',
      maxHeight: '95vh',
    },
  },

  headerScreen: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
    '& svg': {
      fontSize: '28px',
    },
  },

  printableArea: {
    boxSizing: 'border-box',
    border: `1px dashed ${theme.palette.divider}`,
    borderRadius: '8px',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    backgroundColor: '#ffffff', // Forçar fundo branco para etiquetas
    width: '100%',
    transition: 'all 0.3s ease',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },

  etiquetaPequenaArea: {
    padding: theme.spacing(1.5),
  },

  formatoContainer: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2.5),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.action.hover,
    borderRadius: '8px',
    border: `1px solid ${theme.palette.divider}`,
  },

  formatoTitulo: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(1),
  },

  radioLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: '0.875rem',
      fontWeight: 500,
      color: theme.palette.text.secondary,
    },
  },

  botoesContainer: {
    marginTop: theme.spacing(1),
    gap: theme.spacing(2),
  },

  // Estilos de Etiqueta Pequena (L42_PEQUENA)
  etiquetaContainer: {
    height: '100%',
    alignItems: 'center',
  },
  etiquetaTexto: {
    fontSize: '10px',
    lineHeight: 1.2,
    marginBottom: '2px',
    color: '#000000',
  },
  etiquetaDescricao: {
    fontSize: '10px',
    lineHeight: 1.2,
    fontStyle: 'italic',
    marginTop: '2px',
    color: '#000000',
    display: '-webkit-box',
    WebkitLineClamp: 5,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
  },
  etiquetaImpressoPor: {
    fontSize: '8px',
    lineHeight: 1.2,
    fontStyle: 'italic',
    marginTop: '4px',
    color: '#333333',
  },
  qrContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  '@global': {
    '@media print': {
      // Oculta elementos de controle e Backdrop
      '.no-print': { display: 'none !important' },
      'body, #root, .MuiBackdrop-root': { visibility: 'hidden' },

      // Reset e visibilidade da área do modal (papel)
      '#modal-paper': {
        position: 'absolute !important',
        left: '0 !important',
        top: '0 !important',
        margin: '0 !important',
        padding: '0 !important',
        width: 'auto !important',
        height: 'auto !important',
        boxShadow: 'none !important',
        visibility: 'visible !important',
        overflow: 'hidden !important',
        borderRadius: '0 !important',
        minHeight: '100vh',
        minWidth: '100vw',
        backgroundColor: '#ffffff !important',
      },

      // Estilo da área de conteúdo (printableArea)
      '#printable-area': {
        width: '100% !important',
        height: '100% !important',
        padding: '10px !important',
        margin: '0 !important',
        border: 'none !important',
        visibility: 'visible !important',
        position: 'relative',
        boxSizing: 'border-box',
        backgroundColor: '#ffffff !important',
      },

      '.print-corpo-espelho': {
        border: 'none',
        borderRadius: '5px',
        padding: '15px',
        marginTop: '10px',
      },

      // Estilos de elementos internos na impressão
      '#printable-area strong': {
        color: '#111111',
        fontWeight: 700,
        display: 'inline-block',
      },

      '#printable-area svg': {
        width: '70px !important',
        height: '70px !important',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '15px',
      },
    },
  },
}))

export default useStyles
